export const Cashfree = {
  appId: process.env.REACT_APP_CASHFREE_APP_ID
};
